import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { News } from '../../components/news/news.types';
import { catchError, map, Observable, of } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { v4 } from 'uuid';
import { UiModalsService } from '@herrenknecht-connected/angular-shared-ui-modals';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  constructor(
    private httpClient: HttpClient,
    private logger: NGXLogger,
    private uiModalsService: UiModalsService,
    private translateService: TranslateService,
  ) {}

  fetchNews(): Observable<News[]> {
    const cacheId = v4();

    return this.httpClient.get<News[]>(`data/content.json?cacheId=${cacheId}`).pipe(
      map((news) => this.sortNewsByDate(news)),
      catchError((error) => {
        this.uiModalsService.alert(this.translateService.instant('error.fetchNews'));
        this.logger.error('Failed to fetch news items', error);
        return of([] as News[]);
      }),
    );
  }

  private sortNewsByDate(news: News[]): News[] {
    return news.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB.getTime() - dateA.getTime();
    });
  }
}
